import { Modal, Form } from 'antd';

import {
  BankingEntry,
  BankingEntryCreateRequest,
  BankingEntryFormValues,
} from '@/core/domain/financial/BankingEntry/BankingEntry.types';
import BankingEntryForm from '@/components/Financial/Accounts/BankingEntry/BankingEntryForm';
import { useCreateBankingEntry } from '@/core/domain/financial/BankingEntry/BankingEntry.hooks';

interface BankingEntryRegisterModalProps {
  createAgain?: boolean;
  open: boolean;
  onCancel: () => void;
  onFinishCallback?: (bankingEntry: BankingEntry) => void;
}

function BankingEntryRegisterModal({
  open,
  onCancel,
  createAgain,
}: BankingEntryRegisterModalProps) {
  const [form] = Form.useForm<BankingEntryFormValues>();

  const createMutation = useCreateBankingEntry();

  const handleCancel = () => {
    onCancel();
    form.resetFields();
  };

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      const obj: BankingEntryCreateRequest = {
        ...values,
        launchDate: values.launchDate.toISOString(),
        conciliationDate: values.launchDate.toISOString(),
      };

      await createMutation.mutateAsync(obj);

      if (createAgain) {
        form.resetFields();
      } else {
        handleCancel();
      }
    } catch {}
  };

  return (
    <Modal
      open={open}
      onCancel={handleCancel}
      onOk={handleOk}
      title={'Criação de lançamento bancário'}
      width={991}
      confirmLoading={createMutation.isLoading}
    >
      <BankingEntryForm form={form} />
    </Modal>
  );
}

export default BankingEntryRegisterModal;
